/**
 * Application configuration loaded from environment variables.
 */

const config = {
  // API Configuration
  apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:3001',

  // Development User ID (used when auth is not configured)
  devUserId: process.env.REACT_APP_DEV_USER_ID || 'test-user-123',

  // AWS Cognito Configuration (to be configured later)
  cognito: {
    userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || '',
    clientId: process.env.REACT_APP_COGNITO_CLIENT_ID || '',
    domain: process.env.REACT_APP_COGNITO_DOMAIN || '',
    redirectUri: process.env.REACT_APP_REDIRECT_URI || 'http://localhost:3000/callback',
  },

  // Feature flags
  features: {
    authEnabled: process.env.REACT_APP_USE_MOCK_AUTH !== 'true', // Enable auth unless explicitly using mock
    useMockApi: process.env.REACT_APP_USE_MOCK_API === 'true',
  },

  // Validation limits
  validation: {
    maxWordLength: 100,
    maxInterestsLength: 200,
  },

  // Pagination
  defaultPageSize: 20,
  maxPageSize: 100,
};

export default config;
